import { DataTable, DataTablePageEvent } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Column } from "primereact/column";
import { Toast, ToastMessage } from "primereact/toast";
import NewOrderReview from "../New-Invoice-Report/new-order-review";
import OrderPrint from "../New-Invoice-Report/new-order-print";
import { ColumnDef, OrderModel } from "../../models/orders/order-list-model";
import orderServices from "../../services/orders/orderservice";
import { TabPanel, TabView } from "primereact/tabview";
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from 'primereact/dropdown';
import { Button } from "primereact/button";
import TokenService from "../../services/autentication/token.service";
import { userOption, userResult } from '../../models/orders/order-list-model';
import ProductSummary from "./ProductSummary";
import GetAddressByLocation from "../user-address/location-search/get-location";
import UserAddressService from "../../services/useraddress/useraddress.service";
import { generateProductSummaryPDF } from "./DeliveryChallanPDF";
import { DeliveryDetailsModel, ChallanProducts, FilterParams } from "../../models/Delivery-Executive/DeliveryExecutive";
import { newmapInvoiceData } from "../New-Generate-Invoice/new-invoice-mapper-model";
import { selectedGetway } from "../../redux/slices/getway-link";
import RouteConstant from "../../constants/route.constants";
import InvoiceServices from "../../services/invoices/gen_inv.service";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../redux/hooks";
import { GetWayLinkModel } from "../../models/getway-link/getway-link-model";
import NewCreateInvoice from "../New-Generate-Invoice/new-create-invoice";
import { exportCustomerDeliveryReport } from "./CustomerDelieryReport";
import { InputTextarea } from "primereact/inputtextarea";
import EwayForm from "./EWayBill";
import AppLoading from "../app-loading/app-loading";
import ViewChallanDetails from "../View-All-Challan/View-Challan-Details";
import { generateChallanDetailsPDF } from "../View-All-Challan/View-Challan-PDF";
import PaymentConfirmDialog from "../orders/payment-details-dialog";
import DeliveryWorkControls, { DeliveryWorkControlsHandle } from "../delivery-work/DeliveryWorkControls";
import { useCallback } from "react";
import { DeliveryWorkStatus } from "../../models/delivery-work";

const DeliveryDetailsDatatable = () => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const deliveryWork = useRef<DeliveryWorkControlsHandle>(null);
  const [deliveryAccess, setDeliveryAccess] = useState<DeliveryWorkStatus>();
  const deliveryAccessRef = useRef<DeliveryWorkStatus>();
  const reloadOwnOrders = useRef<() => void>(() => {});
  const signedInUser = TokenService.getUser() as { userID?: number; name?: string } | null;
  const deliveryWorkError = useCallback((message: string) => {
    toast.current?.show({ severity: 'error', summary: 'Delivery activity', detail: message, life: 5000 });
  }, []);
  const [visible, setVisible] = useState(false);
  const [orderDetails, setOrderDetails] = useState<OrderModel | null>(null);
  const [dialogHeader, setDialogHeader] = useState(t("orderlist_orderdetails_label"));
  const [printEnabled, setPrintEnabled] = useState(false);
  const [openOrders, setOpenOrders] = useState<DeliveryDetailsModel[]>([]);
  const [openOrdersRows, setOpenOrdersRows] = useState(10);
  const [openOrdersFirst, setOpenOrdersFirst] = useState(0);
  const [openOrdersTotalRecords, setOpenOrdersTotalRecords] = useState(0);
  const [deliveredOrders, setDeliveredOrders] = useState<DeliveryDetailsModel[]>([]);
  const [deliveredOrdersRows, setDeliveredOrdersRows] = useState(10);
  const [deliveredOrdersFirst, setDeliveredOrdersFirst] = useState(0);
  const [deliveredOrdersTotalRecords, setDeliveredOrdersTotalRecords] = useState(0);
  const [delayedOrders, setDelayedOrders] = useState<DeliveryDetailsModel[]>([]);
  const [delayedOrdersRows, setDelayedOrdersRows] = useState(10);
  const [delayedOrdersFirst, setDelayedOrdersFirst] = useState(0);
  const [delayedOrdersTotalRecords, setDelayedOrdersTotalRecords] = useState(0);
  const blankUserDetail: userOption[] = [{ userID: 0, name: '', primaryContactNbr: '' }];
  const [orderUsers, setOrderUsers] = useState<userOption[]>(blankUserDetail);
  const [orderUser, setOrderUser] = useState<userResult[]>([]);
  const [dropdownValue, setDropdownValue] = useState<any>();
  const [showChallanDialog, setShowChallanDialog] = useState(false);
  const [challanProducts, setChallanProducts] = useState<ChallanProducts>({
    categorySummaries: [],
    lineItems: [],
    drivername: ""
  });
  const [isGeneratingChallan, setIsGeneratingChallan] = useState(false);
  const [isLocationMapVisible, setIsLocationMapVisible] = useState(false);
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);
  const [selectedId1, setSelectedId1] = useState<number>(0);
  const [selectedOrderId, setSelectedOrderId] = useState<number | null>(null);
  const [selectedRowData, setSelectedRowData] = useState<DeliveryDetailsModel | null>(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [selectedOrder, setSelectedOrder] = useState<any>({});
  const [createInvoiceVisible, setCreateInvoiceVisible] = useState(false);
  const [showDelayAllConfirm, setShowDelayAllConfirm] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showDelayForm, setShowDelayForm] = useState(false);
  const [delayReasons, setDelayReasons] = useState<{ label: string, value: number }[]>([]);
  const [selectedDelayReason, setSelectedDelayReason] = useState<number | null>(null);
  const [delayDescription, setDelayDescription] = useState<string>('');
  const [currentOrderId, setCurrentOrderId] = useState<number | null>(null);
  const [hasChallanToday, setHasChallanToday] = useState<boolean>(true);
  const [showEwayForm, setShowEwayForm] = useState(false);
  const [currentEwayOrder, setCurrentEwayOrder] = useState<DeliveryDetailsModel | null>(null);
  const [hasEwayBillToday, setHasEwayBillToday] = useState<boolean>(false);
  const [viewInstructionsDialog, setViewInstructionsDialog] = useState(false);
  const [instructions, setInstructions] = useState<{
    delivery: string[];
    customer: string[];
    order: string;
  }>({ delivery: [], customer: [], order: "" });
  const [currentInstructionOrderId, setCurrentInstructionOrderId] = useState<number | null>(null);
  const [addInstructionDialog, setAddInstructionDialog] = useState(false);
  const [newInstruction, setNewInstruction] = useState<string>('');
  const [showChallanListDialog, setShowChallanListDialog] = useState(false);
  const [challanList, setChallanList] = useState<{ challanNo: number; ewayBillNo?: string }[]>([]);
  const [viewDialog, setViewDialog] = useState(false);
  const [selectedChallan, setSelectedChallan] = useState<number | null>(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [paymentOrderData, setPaymentOrderData] = useState<any>(null);

  const showMessage = (label: string, message: string, severity: ToastMessage['severity']) => {
    toast.current?.show({ severity: severity, summary: label, detail: message, life: 3000 });
  };

  const getFormattedAddress = (info: DeliveryDetailsModel) => {
    const parts = [
      info.address1,
      info.address2,
      info.landmark,
      info.areaName,
      info.subDistrictName,
      [info.cityName, info.stateName, info.countryName, info.zipcode ? `-${info.zipcode}` : null].filter(Boolean).join(" "),
    ];
    return parts.filter((part) => part && part.trim() !== "").join(", ");
  };

  const getCurrentLocation = (): Promise<{ latitude: number, longitude: number }> => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const currLocation = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            };
            resolve(currLocation);
          },
          (error) => {
            console.error("Error getting current location:", error.message);
            reject(error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
  };

  const openDirections = (rowData: DeliveryDetailsModel) => {
    const gpsLocation = rowData?.gpsLocation;
    if (!gpsLocation || !gpsLocation.includes(",")) {
      showMessage('Invalid GPS', 'GPS location not available. Please update the GPS.', 'error');
      return;
    }

    const gpsData = gpsLocation.split(",");
    if (gpsData.length !== 2 || isNaN(+gpsData[0]) || isNaN(+gpsData[1])) {
      showMessage('Invalid GPS', 'GPS coordinates are invalid.', 'error');
      return;
    }

    getCurrentLocation()
      .then((currentLocation) => {
        const start = `${currentLocation.latitude},${currentLocation.longitude}`;
        const destination = `${gpsData[0].trim()},${gpsData[1].trim()}`;
        const url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(start)}&destination=${encodeURIComponent(destination)}`;
        window.open(url, '_blank');
      })
      .catch((error) => {
        console.error("Error:", error.message);
        showMessage('Invalid GPS', 'Please update the GPS', 'error');
      });
  };

  const CanFilterExecutives = () => deliveryAccessRef.current?.canFilterExecutives === true;
  const onDeliveryStatus = useCallback((value?: DeliveryWorkStatus) => {
    const wasFiltering = deliveryAccessRef.current?.canFilterExecutives === true;
    deliveryAccessRef.current = value;
    setDeliveryAccess(value);
    if (value?.canFilterExecutives !== true) {
      setDropdownValue(null);
      if (wasFiltering) {
        setOpenOrders([]); setDeliveredOrders([]); setDelayedOrders([]);
        setOpenOrdersTotalRecords(0); setDeliveredOrdersTotalRecords(0); setDelayedOrdersTotalRecords(0);
        reloadOwnOrders.current();
      }
    }
  }, []);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    await fetchOpenOrders();
    await fetchDeliveredOrders();
    await fetchDelayedOrders();
  };
  reloadOwnOrders.current = () => { void fetchInitialData(); };

  /**
   * sortOrdersByLocation  (v3 — phone + GPS grouping)
   *
   * Groups the delivery list so orders at the SAME address for the SAME customer
   * appear consecutively — without merging orders from the customer's OTHER addresses.
   *
   * Grouping key  =  phone  +  GPS rounded to 3 decimal places (~111 m radius).
   *
   * Rules:
   *  • Same phone + same address (~111 m)   → ONE group   → deliver all, then move on
   *  • Same phone + different address far   → TWO groups  → driver visits in route order
   *  • No phone / no GPS                    → solo entry
   *
   * Groups are ordered by the lowest sequenceNo in each group (= visit order).
   * Within each group, orders are sorted by sequenceNo ascending.
   */
  const sortOrdersByLocation = (orders: DeliveryDetailsModel[]): DeliveryDetailsModel[] => {
    if (!orders || orders.length === 0) return orders;

    // Parse "lat,lng" string from the gpsLocation field
    const parseGps = (gpsLocation: string | null | undefined): { lat: number; lng: number } | null => {
      if (!gpsLocation || !gpsLocation.includes(",")) return null;
      const [latStr, lngStr] = gpsLocation.split(",");
      const lat = parseFloat(latStr?.trim());
      const lng = parseFloat(lngStr?.trim());
      return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
    };

    // Grouping key — mirrors getOptimizedRoute.ts v3 logic
    const groupKey = (order: DeliveryDetailsModel): string => {
      const phone = (order as any).customerPhone?.trim();
      const gps = parseGps((order as any).gpsLocation);

      if (phone && gps) {
        // 3 dp ≈ 111 m: same building = same group; different address = different group
        return `ph:${phone}:gps:${gps.lat.toFixed(3)},${gps.lng.toFixed(3)}`;
      }
      if (phone) {
        // Have phone but no GPS — group by phone only (safe fallback)
        return `ph:${phone}:no-gps`;
      }
      if (gps) {
        // No phone but have GPS — group by GPS (4 dp ≈ 11 m)
        return `gps:${gps.lat.toFixed(4)},${gps.lng.toFixed(4)}`;
      }
      // Neither — keep as standalone entry
      return `solo:${order.orderID}`;
    };

    const groupMap = new Map<string, DeliveryDetailsModel[]>();
    for (const order of orders) {
      const key = groupKey(order);
      if (!groupMap.has(key)) groupMap.set(key, []);
      groupMap.get(key)!.push(order);
    }

    // Sort each group internally by sequenceNo
    for (const group of groupMap.values()) {
      group.sort((a, b) => ((a as any).sequenceNo ?? 0) - ((b as any).sequenceNo ?? 0));
    }

    // Sort groups by the minimum sequenceNo within each group (= route visit order)
    const sortedGroups = Array.from(groupMap.values()).sort((groupA, groupB) => {
      const minA = Math.min(...groupA.map((o) => (o as any).sequenceNo ?? 0));
      const minB = Math.min(...groupB.map((o) => (o as any).sequenceNo ?? 0));
      return minA - minB;
    });

    return sortedGroups.flat();
  };

  const fetchOpenOrders = async (filters?: FilterParams) => {
    try {
      const filteredExecutive = CanFilterExecutives() ? filters?.driverId : undefined;
      let response;
      if (CanFilterExecutives()) {
        if (filters?.driverId) {
          response = await orderServices.getAdminDeliveryDetails(Number(filters.driverId));
        } else {
          response = await orderServices.getDeliveryOrders();
        }
      } else {
        response = await orderServices.getDeliveryOrders();
      }
      if (filteredExecutive && !CanFilterExecutives()) return;
      // Sort by location (phone-grouped) before displaying — see sortOrdersByLocation above
      setOpenOrders(sortOrdersByLocation(response.orders || []));
      setOpenOrdersTotalRecords(response.totalCount || 0);
    } catch (error) {
      showMessage("Error", "Failed to load open orders", "error");
    }
  };

  const fetchDeliveredOrders = async (filters?: FilterParams) => {
    try {
      const filteredExecutive = CanFilterExecutives() ? filters?.driverId : undefined;
      let response;
      if (CanFilterExecutives()) {
        if (filters?.driverId) {
          response = await orderServices.getAdminDeliveredDetails(Number(filters.driverId));
        } else {
          response = await orderServices.getDeliveredOrders();
        }
      } else {
        response = await orderServices.getDeliveredOrders();
      }
      if (filteredExecutive && !CanFilterExecutives()) return;
      setDeliveredOrders(response.orders || []);
      setDeliveredOrdersTotalRecords(response.totalCount || 0);
    } catch (error) {
      showMessage("Error", "Failed to load delivered orders", "error");
    }
  };

  const fetchDelayedOrders = async (filters?: FilterParams) => {
    try {
      const filteredExecutive = CanFilterExecutives() ? filters?.driverId : undefined;
      let response;
      if (CanFilterExecutives()) {
        if (filters?.driverId) {
          response = await orderServices.getAdminDelayedDetails(Number(filters.driverId));
        } else {
          response = await orderServices.getDelayedOrders();
        }
      } else {
        response = await orderServices.getDelayedOrders();
      }
      if (filteredExecutive && !CanFilterExecutives()) return;
      setDelayedOrders(response.orders || []);
      setDelayedOrdersTotalRecords(response.totalCount || 0);
    } catch (error) {
      showMessage("Error", "Failed to load delayed orders", "error");
    }
  };

  const fetchDelayStatus = async (keyword: string = '') => {
    try {
      const response = await orderServices.searchDelayStatus({ keyword });
      const formatted = response.map((item: any) => ({
        label: item.Name || item.name || "Unknown Reason",
        value: item.StatusID || item.id || 0
      }));
      setDelayReasons(formatted);
    } catch (error) {
      console.error("Failed to fetch delay reasons:", error);
      showMessage('Error', 'Failed to load delay reasons', 'error');
      setDelayReasons([]);
    }
  };

  const handleFilter = () => {
    if (CanFilterExecutives() && !dropdownValue) {
      showMessage("Warning", "Please select a driver before filtering", "warn");
      return;
    }

    const filters: FilterParams = {};

    if (dropdownValue) {
      filters.driverId = dropdownValue.toString();
    }

    fetchOpenOrders(filters);
    fetchDeliveredOrders(filters);
    fetchDelayedOrders(filters);
  };

  const handleResetFilters = () => {
    setOrderUsers(blankUserDetail);
    fetchOpenOrders();
    fetchDeliveredOrders();
    fetchDelayedOrders();
    setDropdownValue(null);
  };

  const handleSetOrderData = async (rowData: OrderModel) => {
    setVisible(true);
    try {
      const details = await orderServices.GetOrderByOrderId(rowData.orderID);
      if (details) {
        setOrderDetails(details);
      } else {
        showMessage("Warning", "No details found for this order", "warn");
      }
    } catch (error) {
      showMessage("Error", "Failed to fetch order details", "error");
    }
  };

  const handleGenerateInvoice = async (rowData: any) => {
    try {
      const details = await orderServices.GetOrderByOrderIdForInvoice(rowData.orderID);
      if (details) {
        setSelectedOrder(details);
        setCreateInvoiceVisible(true);
      } else {
        console.warn("No details found for order ID:", rowData.orderID);
        showMessage("Warning", "No details found for this order", "warn");
      }
    } catch (error) {
      console.error("Error while fetching order details:", error);
      showMessage("Error", "Failed to fetch order details", "error");
    }
  };

  const handleCreateInvoice = async (event: any, payId: number) => {
    try {
      const checkoutPayId = event.amountPaid > payId ? 0 : payId;
      const invoiceData = newmapInvoiceData(event, payId);
      const response = await InvoiceServices.GenerateNewInvoice(invoiceData);
      if (response.id > 0) {
        showMessage("Success", `Invoice #${response.id} generated successfully`, 'success');
        // 1. Capture the new ID in a local variable
        const newRefId = response.plutusTransactionReferenceID;
        const invoiceAmount = response.paymentAmount
        if ((checkoutPayId === 5 || checkoutPayId === 9) && selectedOrder.paymentAlreadyCharged === false && response.paymentAmount > 0) {
          // 2. Create the data object locally
          selectedOrder.plutusTransactionReferenceId = newRefId;
          selectedOrder.amount = invoiceAmount;
          const newPaymentData = {
            orderId: event.orderID,
            plutusTransactionReferenceId: newRefId, // Use the local variable here
            orderDetails: selectedOrder,
            paymentModeType: checkoutPayId === 5 ? "CARD" : "UPI",
            amount: invoiceAmount
          };
          setPaymentOrderData(newPaymentData);
        }
        else {
          setCreateInvoiceVisible(false);
        }
        await fetchOpenOrders(dropdownValue ? { driverId: dropdownValue } : undefined);
        await fetchDeliveredOrders(dropdownValue ? { driverId: dropdownValue } : undefined);
        await fetchDelayedOrders(dropdownValue ? { driverId: dropdownValue } : undefined);
          if (checkoutPayId === 7 && selectedOrder.paymentAlreadyCharged === false && response.paymentAmount > 0) {
          const getwayData = response.additionalInfo;
          dispatch(selectedGetway(mapAdditionalInfo(getwayData)));
          navigate(RouteConstant.getwayProcess);
        }
      } else {
        showMessage("Error", `${response.message}: Error in generate invoice`, 'error');
        return false;
      }
      return true;
    } catch (error) {
      showMessage("Error", 'Error in generate invoice', 'error');
      return false;
    }
  };

  const mapAdditionalInfo = (data: any): GetWayLinkModel => ({
    paymentURL: data.paymentURL,
    expectedDeliveryDate: data.expectedDeliveryDate,
  });

  const sendWhatsAppMessage = async (orderID: number, messageType: 'deliverywithin_hour' | 'delivery_delayed'): Promise<boolean> => {
    try {
      await orderServices.sendWhatsAppTemplateMessage(orderID, messageType);
      showMessage("Success", `${t(`whatsapp.${messageType}`)} ${t("message_sent")}`, "success");
      return true;
    } catch (error: any) {
      const message = typeof error === "string" ? error : (error?.message || "Unknown error");
      showMessage("Error", `Failed to send message: ${message}`, "error");
      return false;
    }
  };


  const handleDelayAllOrders = async () => {
    setShowDelayAllConfirm(false);

    try {
      const orderIds = openOrders.map((o) => o.orderID);

      if (orderIds.length === 0) {
        showMessage("Error", "No open orders to delay.", "error");
        return;
      }

      // 1️⃣ Update delayed status first
      const updateResult = await orderServices.updateDelayedStatus(orderIds);

      if (!updateResult?.isSuccess) {
        showMessage("Error", updateResult?.message || "Failed to update delayed status.", "error");
        return;
      }

      // 2️⃣ Send WhatsApp messages
      const failedOrders: number[] = [];
      for (const order of openOrders) {
        try {
          await orderServices.sendWhatsAppTemplateMessage(order.orderID, "delivery_delayed");
        } catch (error) {
          failedOrders.push(order.orderID);
        }
      }

      // 3️⃣ Show final message
      if (failedOrders.length === 0) {
        showMessage("Success", updateResult?.message || "All open orders marked delayed and messages sent successfully.", "success");
        await fetchOpenOrders(dropdownValue ? { driverId: dropdownValue } : undefined);
        await fetchDelayedOrders(dropdownValue ? { driverId: dropdownValue } : undefined);
      } else {
        showMessage("Error", `Failed to send messages for orders: ${failedOrders.join(", ")}`, "error");
      }
    } catch (error) {
      console.error("Error delaying all orders:", error);
      showMessage("Error", "Unexpected error occurred while processing delayed orders.", "error");
    }
  };

  const onOpenOrdersPage = (e: DataTablePageEvent) => {
    setOpenOrdersRows(e.rows);
    setOpenOrdersFirst(e.first);
  };

  const onDeliveredOrdersPage = (e: DataTablePageEvent) => {
    setDeliveredOrdersRows(e.rows);
    setDeliveredOrdersFirst(e.first);
  };

  const onDelayedOrdersPage = (e: DataTablePageEvent) => {
    setDelayedOrdersRows(e.rows);
    setDelayedOrdersFirst(e.first);
  };

  const handleDelayedClick = async (orderId: number) => {
    setCurrentOrderId(orderId);
    setSelectedDelayReason(null);
    setDelayDescription('');
    await fetchDelayStatus();
    setShowDelayForm(true);
  };

  const handleDelayFormSubmit = async () => {
    if (!currentOrderId || !selectedDelayReason) {
      showMessage('Warning', 'Please select a reason for delay', 'warn');
      return;
    }

    try {
      const response = await orderServices.saveDeliveryDelay({
        orderID: currentOrderId,
        statusId: selectedDelayReason,
        delayDescription: delayDescription
      });

      if (response.isSuccess) {
        showMessage('Success', 'Delay reason saved successfully', 'success');
        //await sendWhatsAppMessage(currentOrderId, "delivery_delayed");
        await fetchOpenOrders(dropdownValue ? { driverId: dropdownValue } : undefined);
        await fetchDelayedOrders(dropdownValue ? { driverId: dropdownValue } : undefined);
      } else {
        showMessage('Error', response.message || 'Failed to save delay reason', 'error');
      }
    } catch (error) {
      showMessage('Error', 'Failed to save delay reason', 'error');
      console.error('Error saving delay reason:', error);
    } finally {
      setShowDelayForm(false);
    }
  };

  // View existing instructions
  const handleViewInstructions = async (orderID: number) => {
    try {
      const response = await orderServices.getOrderInstructions(orderID);

      if (!response) {
        showMessage("Warning", "No instructions found", "warn");
        return;
      }

      // Split instructions by type
      const deliveryInstructions = response.instructions?.filter((x: any) => x.instructionType === "DI") || [];
      const customerInstructions = response.instructions?.filter((x: any) => x.instructionType === "CI") || [];

      setInstructions({
        delivery: deliveryInstructions.map((i: any) => i.instruction),
        customer: customerInstructions.map((i: any) => i.instruction),
        order: response.orderComments || "",
      });

      setCurrentInstructionOrderId(orderID);
      setViewInstructionsDialog(true);
    } catch (error) {
      console.error("Error fetching instructions:", error);
      showMessage("Error", "Failed to fetch instructions", "error");
    }
  };

  // Add new instruction
  const handleAddInstruction = async (orderID: number) => {
    setCurrentInstructionOrderId(orderID);

    try {
      const response = await orderServices.getOrderInstructions(orderID);

      // Prefill existing delivery instruction if available
      const deliveryInstructions =
        response.instructions?.filter((x: any) => x.instructionType === "DI") || [];

      // Use the first delivery instruction for editing (adjust if multiple)
      setNewInstruction(deliveryInstructions[0]?.instruction || "");

    } catch (error) {
      console.error("Error fetching existing instruction:", error);
      setNewInstruction(''); // fallback if error occurs
    }

    setAddInstructionDialog(true);
  };

  // Save new instruction
  const handleSaveInstruction = async () => {
    if (!newInstruction.trim() || !currentInstructionOrderId) {
      showMessage("Warning", "Please enter a valid instruction", "warn");
      return;
    }

    try {
      // Use an API that handles both add & update
      const response = await orderServices.SaveDeliveryInstruction(
        currentInstructionOrderId,
        newInstruction
      );

      if (response.isSuccess) {
        showMessage("Success", "Instruction saved successfully", "success");
        setAddInstructionDialog(false);

        await fetchOpenOrders(dropdownValue ? { driverId: dropdownValue } : undefined);

        // Refresh view dialog if open
        if (viewInstructionsDialog) {
          await handleViewInstructions(currentInstructionOrderId);
        }
      } else {
        showMessage("Error", response.message || "Failed to save instruction", "error");
      }
    } catch (error) {
      showMessage("Error", "Failed to save instruction", "error");
    }
  };

  const handleViewChallanByNo = async (challanNo: number | null) => {
    try {
      setDetailsLoading(true);
      setSelectedChallan(challanNo);
      setViewDialog(true);
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch challan details.",
      });
    } finally {
      setDetailsLoading(false);
    }
  };

  const baseColumns: ColumnDef[] = [
    {
      field: "orderID",
      header: "Order #",
      sortable: true,
      style: { minWidth: "10rem" },
      body: (rowData: any) => (
        <span
          className="text-blue-500 font-bold cursor-pointer"
          onClick={() => handleSetOrderData(rowData)}
        >
          {rowData.orderID}
        </span>
      ),
    },
    {
      field: "customerName",
      header: "Customer Name",
      sortable: true,
      style: { minWidth: "12rem" },
      body: (rowData: DeliveryDetailsModel) => {
        const flag = rowData.flagCode ?? 0;
        return (
          <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {rowData.customerName}
            {flag === 1 && (
              <span title="Red Flag">
                <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="11" cy="11" r="11" fill="#ef4444" />
                  <path d="M6.5 11.5L9.5 14.5L15.5 8" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            )}
            {flag === 2 && (
              <span title="Blue Verified">
                <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="11" cy="11" r="11" fill="#3b82f6" />
                  <path d="M6.5 11.5L9.5 14.5L15.5 8" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            )}
          </span>
        );
      },
    },
    {
      field: "customerPhone",
      header: "Mobile #",
      sortable: true,
      style: { minWidth: "10rem" },
    },
  ];

  const openOrdersColumns: ColumnDef[] = [
    {
      field: "sequenceNo",
      header: "Sq #",
      sortable: true,
      style: { minWidth: "6rem", textAlign: "center" },
    },
    ...baseColumns,
    {
      field: "actions",
      header: "Actions",
      style: { minWidth: "10rem", textAlign: "center" },
      body: (rowData: DeliveryDetailsModel) => (
        <div className="flex gap-2 justify-content-center">
          <Button
            icon="pi pi-map-marker"
            onClick={() => { setIsLocationMapVisible(true); setSelectedId1(rowData.userAddressID); setSelectedRowData(rowData); setSelectedOrderId(rowData.orderID); }}
            className="p-button-rounded p-button-text p-button-secondary"
            tooltip="Set location"
            tooltipOptions={{ position: 'top' }}
          />
          <Button
            icon="pi pi-directions"
            onClick={() => openDirections(rowData)}
            className="p-button-rounded p-button-text p-button-help"
            disabled={!rowData?.gpsLocation}
            tooltip="Open directions"
            tooltipOptions={{ position: 'top' }}
          />
          <button
            className="p-button p-button-sm p-button-rounded p-button-success"
            style={{ padding: "0.3rem 0.6rem", fontSize: "0.75rem" }}
            onClick={() => sendWhatsAppMessage(rowData.orderID, "deliverywithin_hour")}
          >
            <i className="pi pi-clock mr-1" />
            Within Hour
          </button>
          <button
            className="p-button p-button-sm p-button-rounded p-button-warning"
            style={{ padding: "0.3rem 0.6rem", fontSize: "0.75rem" }}
            onClick={() => handleDelayedClick(rowData.orderID)}
          >
            <i className="pi pi-hourglass-end mr-1" />
            Delayed
          </button>
          <Button
            label="Generate Invoice"
            className="p-button p-button-success"
            onClick={() => handleGenerateInvoice(rowData)}
          />
          {rowData.hasInstruction && (
            <Button
              icon="pi pi-book"
              className="p-button-rounded p-button-text p-button-warning"
              tooltip="View Instructions"
              tooltipOptions={{ position: 'top' }}
              onClick={() => handleViewInstructions(rowData.orderID)}
            />
          )}

          <Button
            icon={rowData.hasInstruction ? "pi pi-pencil" : "pi pi-plus"}
            className={`p-button-rounded p-button-text ${rowData.hasInstruction ? "p-button-warning" : "p-button-info"}`}
            tooltip={rowData.hasInstruction ? "Edit Instruction" : "Add Instruction"}
            tooltipOptions={{ position: 'top' }}
            onClick={() => handleAddInstruction(rowData.orderID)}
          />
        </div>
      ),
    },
  ];

  const delayedOrdersColumns: ColumnDef[] = [
    ...baseColumns,
    {
      field: "delayedStatus",
      header: "Delay Status",
      sortable: true,
      style: { minWidth: "15rem" },

    },
    {
      field: "delayedDescription",
      header: "Delay Reason",
      sortable: true,
      style: { minWidth: "20rem" },
    }
  ];

  const hideDialog = () => {
    setVisible(false);
  };

  const handleTriggerPrint = (val: boolean) => {
    setPrintEnabled(val);
  };

  const handleDropdownChange = (e: DropdownChangeEvent) => {
    if (!CanFilterExecutives()) return;
    const selectedUserId = e.value;
    const selectedUser = orderUser.find(user => user.userID === selectedUserId);

    if (selectedUser) {
      setDropdownValue(selectedUserId);
    }
  };

  const handleDropdownFilter = (e: DropdownFilterEvent) => {
    if (!CanFilterExecutives()) return;
    if (e.filter.length > 2) {
      orderServices.getDriversList(e.filter).then((response: userOption[]) => {
        if (response.length > 0) {
          setOrderUsers(response);
        }
      });
    }
  };

  useEffect(() => {
    setOrderUser(orderUsers.map((user) => ({
      userID: user.userID,
      detail: user.userID !== 0 ? `${user.name}, ${user.primaryContactNbr}` : "",
    })));
  }, [orderUsers]);

  const updateLatitudeAndLongitude = (location: string) => {
    if (location) {
      try {
        var locationSplit = location.split(",");
        setLatitude(parseFloat(locationSplit[0]));
        setLongitude(parseFloat(locationSplit[1]));
      } catch {
      }
    }
  }

  const updateGpsLocation = async (latLng: any) => {
    setIsLocationMapVisible(false);
    updateLatitudeAndLongitude(latLng);
    if (latLng && selectedId1 != null && selectedOrderId != null) {
      const response = await UserAddressService.updateGPSLocation1(selectedId1, latLng, selectedOrderId);
      if (response && response.isSuccess) {
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: 'GPS location updated successfully.',
          life: 3000,
        });
        setTimeout(async () => {
          await fetchOpenOrders(dropdownValue ? { driverId: dropdownValue } : undefined);
        }, 1000);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: response?.message || 'Failed to update GPS location.',
          life: 3000,
        });
      }
    }
  }

  const handleGenerateChallan = async () => {
    try {
      setIsGeneratingChallan(true);
      const response = await orderServices.createChallan();

      if (response.isSuccess) {
        showMessage("Success", "Challan generated and WhatsApp notifications sent successfully!", "success");
        await fetchOpenOrders(dropdownValue ? { driverId: dropdownValue } : undefined);
        // await handleViewChallan();

        if (openOrders.length > 0) {
          const orderToEway = openOrders[0];
          setCurrentEwayOrder(orderToEway);
          setShowEwayForm(true);

        }

      } else {
        showMessage("Error", response.message || "Failed to generate challan", "error");
      }
    } catch (error: any) {
      console.error('Error generating challan:', error);
      showMessage("Error", error.message || "Failed to generate challan", "error");
    } finally {
      setIsGeneratingChallan(false);
    }
  };

  const handleViewChallan = async () => {
    try {
      const response = await orderServices.getChallanProducts();

      const emptyState: ChallanProducts = {
        categorySummaries: [],
        lineItems: [],
        drivername: "",
        totalChallansToday: 0,
        challanSummaries: [],
        vesselDetails: []
      };

      if (!response) {
        showMessage("Warning", "No records found to generate challan", "warn");
        setChallanProducts(emptyState);
        setShowChallanDialog(true);
        await generateProductSummaryPDF(emptyState);
        return;
      }

      const isChallanProducts = (obj: any): obj is ChallanProducts => {
        return (
          (Array.isArray(obj.categorySummaries) || obj.categorySummaries === undefined) &&
          (Array.isArray(obj.lineItems) || obj.lineItems === undefined)
        );
      };

      const productsData: ChallanProducts = isChallanProducts(response)
        ? {
          categorySummaries: response.categorySummaries || [],
          lineItems: response.lineItems || [],
          drivername: response.drivername,
          totalChallansToday: response.totalChallansToday || 0,
          challanSummaries: response.challanSummaries || [],
          vesselDetails: response.vesselDetails || []
        }
        : emptyState;


      // ✅ NEW: If multiple challans today, show list dialog
      if (
        (productsData?.totalChallansToday ?? 0) > 1 &&
        (productsData.challanSummaries?.length ?? 0) > 0
      ) {
        setChallanList(productsData.challanSummaries ?? []);
        setShowChallanListDialog(true);
        return;
      }

      if (productsData.categorySummaries.length === 0 && productsData.lineItems.length === 0) {
        showMessage("Warning", "No products found in the challan", "warn");
        return;
      }

      setChallanProducts(productsData);
      setShowChallanDialog(true);
      await generateProductSummaryPDF(productsData);
    } catch (error) {
      showMessage("Error", "Failed to load challan products", "error");
      await generateProductSummaryPDF({
        categorySummaries: [],
        lineItems: [],
      });
    }
  };

  const hideCreateInvoiceDialog = () => {
    setCreateInvoiceVisible(false);
  };

  const handleViewReport = async () => {
    try {
      if (openOrders.length === 0) {
        showMessage("Warning", "No records found to export customer report", "warn");
        return;
      }
      await exportCustomerDeliveryReport();
      showMessage("Success", "Customer report generated successfully", "success");
    } catch (error) {
      console.error("Error generating customer report:", error);
      showMessage("Error", "Failed to generate customer report", "error");
    }
  };

  const totalOrdersCount = (openOrdersTotalRecords || 0) +
    (deliveredOrdersTotalRecords || 0) +
    (delayedOrdersTotalRecords || 0);

  const hideConfirmDialog = () => {
    setShowPaymentDialog(false);
    setPaymentOrderData(null);
  };

  return (
    <div className="card">
      <DeliveryWorkControls ref={deliveryWork} onError={deliveryWorkError} onStatusChange={onDeliveryStatus} />
      <div className="flex justify-content-between align-items-center mb-3">
        <h5 className="ml-1 mb-0">Delivery Assessment</h5>

        <div className="flex gap-2">
          {activeTabIndex === 0 && (
            <>
              <Button
                label="Generate Challan"
                icon="pi pi-file-pdf"
                onClick={handleGenerateChallan}
                loading={isGeneratingChallan}
                className="p-button-primary"
              />

              <Button
                label="Generate E-Way Bill"
                icon="pi pi-file"
                className="p-button-success"
                onClick={async () => {
                  try {
                    const challanResponse = await orderServices.getChallanProducts();

                    const challanData = Array.isArray(challanResponse)
                      ? challanResponse[0]
                      : challanResponse;

                    if (challanData && challanData.lineItems?.length > 0) {
                      const hasEwayBill = challanData.lineItems.some(
                        (item: any) => item.ewayBillNo && item.ewayBillNo.trim() !== ""
                      );

                      if (hasEwayBill) {
                        showMessage("Info", "E-Way Bill has already been generated for the recent challan.", "info");
                        return;
                      }
                    }

                    if (openOrders.length > 0) {
                      setCurrentEwayOrder(openOrders[0]);
                      setShowEwayForm(true);
                    } else {
                      showMessage("Warning", "No open orders available for E-Way Bill", "warn");
                    }
                  } catch (error) {
                    showMessage("Error", "Failed to check challan E-Way Bill status.", "error");
                  }
                }}
              />

              <Button
                label="View Challan"
                icon="pi pi-eye"
                onClick={handleViewChallan}
                className="p-button-success"
              />

              <Button
                label="Customer Report"
                icon="pi pi-eye"
                onClick={handleViewReport}
                className="p-button-success"
              />
            </>
          )}
        </div>
      </div>
      <Toast ref={toast} position="top-center" />

        <div className="col-12 mb-4 p-fluid">
          <div className="grid p-3 border-round border-1 surface-border">
            <div className="col-12 md:col-3">
              <Dropdown
                id="SearchUser"
                aria-label="Delivery executive"
                name="SearchUser"
                options={deliveryAccess?.canFilterExecutives ? orderUser || [] : [{ userID: signedInUser?.userID, detail: signedInUser?.name || 'Your assigned orders' }]}
                optionLabel="detail"
                optionValue="userID"
                value={deliveryAccess?.canFilterExecutives ? dropdownValue : signedInUser?.userID}
                disabled={!deliveryAccess?.canFilterExecutives}
                onChange={handleDropdownChange}
                onFilter={handleDropdownFilter}
                filter
                placeholder="Search for User/Mobile"
                className="w-full"
              />
            </div>
            <div className="col-12 md:col-3 flex align-items-end gap-2">
              <Button
                label="Filter"
                icon="pi pi-filter"
                disabled={!deliveryAccess?.canFilterExecutives}
                onClick={handleFilter}
              />
              <Button
                label="Reset"
                disabled={!deliveryAccess?.canFilterExecutives}
                icon="pi pi-refresh"
                onClick={handleResetFilters}
              />
            </div>
          </div>
        </div>
      <span className="font-bold" >
        Total Orders: {totalOrdersCount || 0}
      </span>
      <div className="col-12 card border-noround p-2">
        <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
          {/* Open Orders Table */}
          <TabPanel header="Yet To Deliver" leftIcon="pi pi-inbox mr-2">
            <div className="flex align-items-center justify-content-between mb-3">
              <div className="flex align-items-center gap-2">
                <span className="font-bold">Yet To Deliver: {openOrdersTotalRecords || 0}</span>
              </div>
              <div>
                <Button
                  label="Delay Orders"
                  icon="pi pi-clock"
                  className="p-button-warning p-button"
                  onClick={() => setShowDelayAllConfirm(true)}
                  disabled={openOrders.length === 0}
                />
              </div>
            </div>
            <DataTable
              value={openOrders}
              paginator
              rows={openOrdersRows}
              first={openOrdersFirst}
              totalRecords={openOrdersTotalRecords}
              rowsPerPageOptions={[5, 10, 25]}
              onPage={onOpenOrdersPage}
              stripedRows
              showGridlines
              emptyMessage="No open orders found."
              sortMode="multiple"
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              className="p-datatable-sm"
            >
              {openOrdersColumns.map((col, i) => (
                <Column
                  key={`open-${i}`}
                  field={col.field}
                  header={col.header}
                  sortable={col.sortable}
                  style={col.style}
                  body={col.body}
                />
              ))}
            </DataTable>
          </TabPanel>

          {/* Delivered Orders Table */}
          <TabPanel header="Delivered" leftIcon="pi pi-check-circle mr-2">
            <div className="flex align-items-center justify-content-between mb-3">
              <div className="flex align-items-center gap-2">
                <span className="font-bold">Delivered: {deliveredOrdersTotalRecords || 0} </span>
              </div>
            </div>

            <DataTable
              value={deliveredOrders}
              paginator
              rows={deliveredOrdersRows}
              first={deliveredOrdersFirst}
              totalRecords={deliveredOrdersTotalRecords}
              rowsPerPageOptions={[5, 10, 25]}
              onPage={onDeliveredOrdersPage}
              stripedRows
              showGridlines
              emptyMessage="No delivered orders found."
              sortMode="multiple"
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              className="p-datatable-sm"
            >
              {baseColumns.map((col, i) => (
                <Column
                  key={`delivered-${i}`}
                  field={col.field}
                  header={col.header}
                  sortable={col.sortable}
                  style={col.style}
                  body={col.body}
                />
              ))}
            </DataTable>
          </TabPanel>

          {/* Delayed Orders Table */}
          <TabPanel header="Delayed" leftIcon="pi pi-hourglass mr-2">
            <div className="flex align-items-center justify-content-between mb-3">
              <div className="flex align-items-center gap-2">
                <span className="font-bold">Delayed: {delayedOrdersTotalRecords || 0} </span>
              </div>
            </div>

            <DataTable
              value={delayedOrders}
              paginator
              rows={delayedOrdersRows}
              first={delayedOrdersFirst}
              totalRecords={delayedOrdersTotalRecords}
              rowsPerPageOptions={[5, 10, 25]}
              onPage={onDelayedOrdersPage}
              stripedRows
              showGridlines
              emptyMessage="No delayed orders found."
              sortMode="multiple"
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              className="p-datatable-sm"
            >
              {delayedOrdersColumns.map((col, i) => (
                <Column
                  key={`delayed-${i}`}
                  field={col.field}
                  header={col.header}
                  sortable={col.sortable}
                  style={col.style}
                  body={col.body}
                />
              ))}
            </DataTable>
          </TabPanel>
        </TabView>
      </div>

      {/* Order Details Dialog */}
      {orderDetails && (
        <Dialog
          header={dialogHeader}
          visible={visible}
          style={{ width: "67vw" }}
          onHide={hideDialog}
          breakpoints={{ '960px': '75vw', '640px': '90vw' }}
          modal
        >
          <TabView>
            <TabPanel header="Order Details" leftIcon="pi pi-file mr-2">
              <NewOrderReview
                TriggerPrint={handleTriggerPrint}
                PrintEnabled={printEnabled}
                OrderData={<OrderPrint orderinfo={orderDetails} />}
              />
            </TabPanel>
          </TabView>
        </Dialog>
      )}

      {/* Delay Reason Form Dialog */}
      <Dialog
        header="Delivery Delay Reason"
        visible={showDelayForm}
        style={{ width: '50vw' }}
        onHide={() => setShowDelayForm(false)}
        footer={
          <div>
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={() => setShowDelayForm(false)}
              className="p-button-text"
            />
            <Button
              label="Save"
              icon="pi pi-check"
              onClick={handleDelayFormSubmit}
              autoFocus
            />
          </div>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="delayReason">Reason for Delay</label>
            <Dropdown
              id="delayReason"
              value={selectedDelayReason}
              options={delayReasons}
              optionLabel="label"
              optionValue="value"
              onChange={(e) => setSelectedDelayReason(e.value)}
              placeholder="Select a reason"
              className="w-full"
              style={{
                border: '2px solid #C8E6C9',
                borderRadius: '4px',
                transition: 'all 0.3s ease'
              }}
            />
          </div>
          <div className="field">
            <label htmlFor="delayDescription">Note (Optional)</label>
            <InputTextarea
              id="delayDescription"
              value={delayDescription}
              onChange={(e) => setDelayDescription(e.target.value)}
              rows={3}
              className="w-full"
              style={{
                border: '2px solid #C8E6C9',
                borderRadius: '4px',
                transition: 'all 0.3s ease'
              }}
              placeholder="Provide additional details about the delay"
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        header="Search your location"
        className="location-dialog"
        visible={isLocationMapVisible}
        onHide={() => setIsLocationMapVisible(false)}
        footer=""
        style={{ width: "50%" }}
      >
        <GetAddressByLocation
          getLatitudeLongitude={updateGpsLocation}
          lat={latitude}
          lng={longitude}
          formattedAddress={selectedRowData ? getFormattedAddress(selectedRowData) : ""}
        />
      </Dialog>

      {/* Challan Dialog */}
      <Dialog
        header="Delivery Challan"
        visible={showChallanDialog}
        style={{ width: "80vw" }}
        onHide={() => setShowChallanDialog(false)}
        breakpoints={{ '960px': '95vw', '640px': '100vw' }}
        modal
      >
        <ProductSummary
          categorySummaries={challanProducts.categorySummaries}
          lineItems={challanProducts.lineItems}
          drivername={challanProducts.drivername}
          vesselDetails={challanProducts.vesselDetails ?? []}
        />
      </Dialog>

      <Dialog
        header="Generate Invoice"
        visible={createInvoiceVisible}
        style={{ width: "80vw", maxWidth: "1200px" }}
        onHide={hideCreateInvoiceDialog}
        className="create-invoice-dialog"
      >
        {selectedOrder && Object.keys(selectedOrder).length > 0 && (
          <NewCreateInvoice
            beforeCreateInvoice={() => deliveryWork.current?.ensureStarted(selectedOrder.orderID) ?? Promise.resolve(false)}
            OrderData={selectedOrder}
            runHideDialog={hideCreateInvoiceDialog}
            setOrderData={setSelectedOrder}
            runCreateInvoice={handleCreateInvoice}
          />
        )}
      </Dialog>

      <Dialog
        header="Confirm Delay All"
        visible={showDelayAllConfirm}
        onHide={() => setShowDelayAllConfirm(false)}
        modal
        footer={
          <div className="flex justify-content-end gap-2">
            <Button label="No" icon="pi pi-times" onClick={() => setShowDelayAllConfirm(false)} className="p-button-text" />
            <Button label="Yes" icon="pi pi-check" onClick={handleDelayAllOrders} autoFocus />
          </div>
        }
      >
        <p>Are you sure you want to send delay messages to all open orders?</p>
      </Dialog>

      <Dialog
        header="Generate E-Way Bill"
        visible={showEwayForm}
        style={{ width: "50vw" }}
        onHide={() => setShowEwayForm(false)}
        modal
        breakpoints={{ '960px': '75vw', '640px': '90vw' }}
      >
        {currentEwayOrder && (
          <EwayForm
            order={currentEwayOrder}
            onCancel={() => setShowEwayForm(false)}
            onSuccess={async () => {
              await fetchOpenOrders(dropdownValue ? { driverId: dropdownValue } : undefined);
            }}
          />
        )}
      </Dialog>

      {/* === View Instructions Dialog === */}
      <Dialog
        header="View Instructions"
        visible={viewInstructionsDialog}
        style={{ width: "40vw", maxHeight: "80vh" }}
        modal
        onHide={() => setViewInstructionsDialog(false)}
      >
        <div className="p-fluid">
          {/* Customer Instructions */}
          <div className="mb-3 rounded-lg p-3"
            style={{
              border: "1px solid #4a90e2", // blue border
              borderRadius: "8px",
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            <h5 className="mb-2" style={{ color: "#4a90e2" }}>Customer Instructions</h5>
            {instructions.customer.length > 0 ? (
              <ul style={{ paddingLeft: "1.2rem", margin: 0 }}>
                {instructions.customer.map((inst, i) => (
                  inst
                    .split(/\r?\n/)
                    .filter(line => line.trim() !== "")
                    .map((line, j) => (
                      <li key={`${i}-${j}`} style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", overflowWrap: "anywhere", }}>
                        {line}
                      </li>
                    ))
                ))}
              </ul>
            ) : (
              <p className="text-500">No customer instructions.</p>
            )}
          </div>

          {/* Delivery Instructions */}
          <div
            className="mb-3 rounded-lg p-3"
            style={{
              border: "1px solid #50b24f", // green border
              borderRadius: "8px",
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            <h5 className="mb-2" style={{ color: "#50b24f" }}>Delivery Instructions</h5>
            {instructions.delivery.length > 0 ? (
              <ul style={{ paddingLeft: "1.2rem", margin: 0 }}>
                {instructions.delivery.map((inst, i) => (
                  inst
                    .split(/\r?\n/)
                    .filter(line => line.trim() !== "")
                    .map((line, j) => (
                      <li key={`${i}-${j}`} style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", overflowWrap: "anywhere", }}>
                        {line}
                      </li>
                    ))
                ))}
              </ul>
            ) : (
              <p className="text-500">No delivery instructions.</p>
            )}
          </div>

          {/* Order Specific Instructions */}
          <div
            className="rounded-lg p-3"
            style={{
              border: "1px solid #f5a623", // amber border
              borderRadius: "8px",
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            <h5 className="mb-2" style={{ color: "#f5a623" }}>Order Specific Instructions</h5>
            {instructions.order ? (
              <ul style={{ paddingLeft: "1.2rem", margin: 0 }}>
                {instructions.order
                  .split(/\r?\n/)
                  .filter(line => line.trim() !== "")
                  .map((line, i) => (
                    <li key={i} style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", overflowWrap: "anywhere", }}>
                      {line}
                    </li>
                  ))}
              </ul>
            ) : (
              <p className="text-500">No order-specific instructions.</p>
            )}
          </div>
        </div>
      </Dialog>

      {/* === Add/Edit Instruction Dialog === */}
      <Dialog
        header={`${newInstruction ? "Edit" : "Add"} Delivery Instruction `}
        visible={addInstructionDialog}
        style={{ width: "40vw" }}
        onHide={() => setAddInstructionDialog(false)}
        modal
        footer={
          <div className="flex justify-content-end gap-2">
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={() => setAddInstructionDialog(false)}
              className="p-button-text"
            />
            <Button
              label="Save"
              icon="pi pi-check"
              onClick={handleSaveInstruction}
              autoFocus
            />
          </div>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="newInstruction">Instruction</label>
            <InputTextarea
              id="newInstruction"
              value={newInstruction}
              onChange={(e) => setNewInstruction(e.target.value)}
              rows={4}
              placeholder="Enter new instruction"
              style={{
                border: "2px solid #9bd39dff",
                borderRadius: "4px",
                padding: "0.5rem",
                boxShadow: "none",
                outline: "none",
              }}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        header="Today's Challans"
        visible={showChallanListDialog}
        style={{ width: "50vw" }}
        modal
        onHide={() => setShowChallanListDialog(false)}
      >
        {challanList.length > 0 ? (
          <div className="p-fluid">
            <table className="w-full border-collapse">
              <thead>
                <tr style={{ backgroundColor: "#f4f4f4", textAlign: "left" }}>
                  <th className="p-2 border">Challan #</th>
                  <th className="p-2 border">E-Way Bill #</th>
                  <th className="p-2 border text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {challanList.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-100">
                    <td className="p-2 border font-semibold">{item.challanNo}</td>
                    <td className="p-2 border">{item.ewayBillNo || "-"}</td>
                    <td className="p-2 border text-center">
                      <div className="flex justify-content-center gap-2">
                        <Button
                          label="View"
                          icon="pi pi-eye"
                          className="p-button-sm p-button-text p-button-primary"
                          onClick={() => {
                            handleViewChallanByNo(item.challanNo);
                          }}
                        />

                        <Button
                          label="Download"
                          icon="pi pi-download"
                          className="p-button-sm p-button-text p-button-success"
                          onClick={async () => {
                            try {
                              await generateChallanDetailsPDF(item.challanNo);
                              showMessage("Success", `Challan #${item.challanNo} downloaded successfully`, "success");
                            } catch (error) {
                              console.error("Error downloading challan:", error);
                              showMessage("Error", "Failed to download challan PDF", "error");
                            }
                          }}
                        />

                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No challans found for today.</p>
        )}
      </Dialog>

      {/* === View Challan Dialog === */}
      <Dialog
        header="Challan Details"
        visible={viewDialog}
        style={{ width: "70vw" }}
        modal
        onHide={() => setViewDialog(false)}
      >
        {detailsLoading ? (
          <AppLoading />
        ) : selectedChallan ? (
          <ViewChallanDetails challanNo={selectedChallan} />
        ) : (
          <div className="text-center p-4">No challan details found.</div>
        )}
      </Dialog>
      <PaymentConfirmDialog
        showConfirmDialog={showPaymentDialog}
        hideConfirmDialog={hideConfirmDialog}
        orderId={paymentOrderData?.orderId}
        PlutusTransactionReferenceId={paymentOrderData?.plutusTransactionReferenceId}
        orderDetails={paymentOrderData?.orderDetails}
        paymentModeType={paymentOrderData?.paymentModeType}
        Amount={paymentOrderData?.amount}
      />
    </div>
  );
};

export default DeliveryDetailsDatatable;
